import { useMedia } from "react-use"
import { useEffect } from "react"
import { useLocation } from "react-router"

import { SearchPageLink } from "app/AppRouter/links/SearchPageLink"
import { AfterFooter } from "components"
import { Client, Psychologist } from "utils/interfaces"
import { CURRENCY } from "utils/constants"
import { INITIATOR } from "modules/BookingCommon/components/DatePicker/constants"
import {
    Card,
    NextPageButton,
    SessionInfoCard,
} from "modules/BookingCommon/components/CardsPage/components"
import { ServicesGroup } from "utils/helpers/ServicesGroup"

interface Props {
    serviceGroups: ServicesGroup[]
    serviceGroup: ServicesGroup | undefined
    psy: Psychologist
    currency: CURRENCY
    showDiscount: boolean
    initiator: INITIATOR
    client?: Client
    hasSlots?: boolean
    onChangeCurrency?: (currency: CURRENCY) => void

    onChangeServiceGroup: (card: ServicesGroup) => void
    onChangeIsChooseManuallyService?: (value: boolean) => void
    nextPage: () => void
    onClickNextPage?: () => void
}

export function CardsPage({
    serviceGroups,
    serviceGroup,
    psy,
    currency,
    showDiscount,
    initiator,
    client,
    hasSlots,
    onChangeCurrency,
    onChangeServiceGroup,
    onChangeIsChooseManuallyService,
    nextPage,
    onClickNextPage,
}: Props) {
    const singleGroupAvailable = serviceGroups.length === 1
    const minWidth = useMedia("(min-width: 992px)")
    const isBookingAvailable = Boolean(serviceGroup?.availableStatusWithCompany.ok)
    const { key } = useLocation()
    useEffect(() => {
        onChangeCurrency?.(CURRENCY.RUB)
    }, [])

    return (
        <div className="redesign-container">
            <div className="is-flex booking-cards__wrapper">
                <div className="booking-cards__cards">
                    {serviceGroups.map((group, index) => (
                        <Card
                            key={group.id}
                            singleServiceAvailable={singleGroupAvailable}
                            group={group}
                            square={!singleGroupAvailable && index < 2 && minWidth}
                            serviceGroup={serviceGroup}
                            psy={psy}
                            currency={currency}
                            showDiscount={showDiscount}
                            initiator={initiator}
                            hasSlots={hasSlots}
                            onChangeServiceGroup={onChangeServiceGroup}
                            onChangeIsChooseManuallyService={onChangeIsChooseManuallyService}
                        />
                    ))}
                </div>
                {isBookingAvailable && (
                    <SessionInfoCard
                        serviceGroup={serviceGroup}
                        psy={psy}
                        currency={currency}
                        nextPage={nextPage}
                        initiator={initiator}
                        client={client}
                        onClickNextPage={onClickNextPage}
                    />
                )}
            </div>
            {!isBookingAvailable && initiator === INITIATOR.CLIENT && (
                <div className="booking-cards__not-available-button">
                    <SearchPageLink className="booking__primary-button transition-ease booking-cards__not-available-button--hover">
                        Выбрать другого психолога
                    </SearchPageLink>
                </div>
            )}
            {isBookingAvailable && (
                <AfterFooter afterFooterKey={key}>
                    <NextPageButton
                        regimen="mobile"
                        serviceGroup={serviceGroup}
                        psy={psy}
                        nextPage={nextPage}
                        initiator={initiator}
                        onClickButton={onClickNextPage}
                    />
                </AfterFooter>
            )}
        </div>
    )
}
